import { EventHandler, MouseEventHandler } from "react";

export const API_STATUS = {
  success: 200,
  timeout: 504,
  unauthorized: 401,
};

export type TPagination = {
  current_page: number;
  per_page: number;
  data_from_offset: number;
  data_to_offset: number;
  total_pages: number;
  total_records: number;
};

export type TReportTableOptions = {
  title: string;
  subtitle?: string;
  type: string;
  showOptions: boolean;
  onClickPdf: MouseEventHandler;
  onClickPrint: MouseEventHandler;
  csvData?: object[];
  containerStyle?: object;
  isLoading?: boolean;
  onExcelFile?: (filename: string) => void;
};
